import React, { memo, useEffect, useState } from "react";
import Pagination from '@mui/material/Pagination';
import { Stack } from "@mui/material";

import OffcanvasTemplate from "../../components/offcanvasTemplate";
import { theme } from "../../theme";
import { findRequestDetails } from "./service";
import DivSpinner from "../../components/divSpinner";
import RequestDetailsCard from "./components/RequestDetailsCard";
import ExtraMaterials from "./components/ExtraMaterials";
import CostBreakdown from "./components/CostBreakdown";

const FtmRequests = ({job_id, show, handleClose, undecided = false}) => {
    const [page, setPage] = useState(1);
    const [requestDetails, setRequestDetails] = useState({
        loading: true,
        details: [],
        error: null,
    });

    useEffect(() => {
        const fetchRequestDetails = async () => {
            try {
                setRequestDetails({ loading: true, details: [], error: null });
                const response = await findRequestDetails(job_id, undecided);
                if (response?.status === "Success") {
                    setRequestDetails({ loading: false, details: response.details, error: null });
                } else {
                    throw new Error(response?.message || "Failed to fetch details");
                }
            } catch (error) {
                setRequestDetails({ loading: false, details: [], error: error.message });
            }
        };

        fetchRequestDetails();
    }, [job_id]);

    const FooterBtn = memo(() => (
        <div className="container">
            <div className="row mt-3 mb-3">
                <div className="col">
                    <Stack 
                        spacing={2} 
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center'
                        }}      
                    >
                        <Pagination 
                            count={requestDetails.details.ftm_requests?.length} 
                            page={page} 
                            onChange={(event, newPage) => setPage(newPage)} 
                            color={theme.main}
                        />
                    </Stack>
                </div>
            </div>
        </div>
    ));

    return (
        <OffcanvasTemplate
            open={show}
            handleClose={() => handleClose()}
            placement="end"
            title="Job Materials"
            body={
                <>
                    {requestDetails.loading && <DivSpinner />}
                    {requestDetails.error && <p className="text-danger">{requestDetails.error}</p>}
                    {(!requestDetails.loading && !requestDetails.error && requestDetails.details.ftm_requests.length > 0) ? (
                        <>
                            <RequestDetailsCard 
                                key={requestDetails.details.ftm_requests[page-1]?.ftm_request_id} 
                                request={requestDetails.details.ftm_requests[page-1]} 
                            />
                            {requestDetails.details.ftm_requests[page-1]?.request_materials.map((material, index) => (
                                <ExtraMaterials key={index} material={material} />
                            ))}

                            <CostBreakdown
                                total_material_net_price={requestDetails.details.ftm_requests[page-1]?.ftm_request_total_material_net_price}
                            />

                            <hr className="horizontal white mt-0 mb-2" />
                        </>
                    ) : <p className="text-center pt-3 mt-3">No material found</p>}
                </>
            }
            footer={<FooterBtn/>}
        />
    );
}

export default FtmRequests;